export const resources = {
  resourcesFolderInfoText: 'Arquivo(s)',
  resourcesItemInfoLastUpdText: 'Última atualização',
  resourcesItemInfoUploadedText: 'Enviado',
  resourcesSearchInputText: 'Pesquisar',
  resourcesUserActionSheetOptionTitle: 'Copiar link',
  resourcesActionCopiedAlertText: 'Link copiado!',
  resourcesOwnersCurtainEditOptionText: 'Editar título',
  resourcesOwnersCurtainDeleteOptionText: 'Excluir',
  resourcesOwnerCurtainHideOptionText: 'Ocultar (Inativo)',
  resourcesEditPopupTitle: 'Editar título',
  resourcesEditPopupResetButtonTitle: 'Redefinir',
  resourcesEditPopupApplyButtonTitle: 'Aplicar',
  resourcesItemEditedAlertText: 'O item foi atualizado com sucesso!',
  resourcesHidePopupTitle: 'Ocultar',
  resourcesHidePopupText: 'Ocultar este item?',
  resourcesHidePopupCancelButtonTitle: 'Cancelar',
  resourcesHidePopupConfirmButtonTitle: 'Confirmar',
  resourcesDeletePopupTitle: 'Excluir',
  resourcesDeletePopupText: 'Excluir este item?',
  resourcesDeletePopupCancelButtonTitle: 'Cancelar',
  resourcesDeletePopupConfirmButtonTitle: 'Confirmar',
  resourcesItemDeletedAlertText: 'O item foi excluído com sucesso!',
  resourceDetailsLinkText: 'Este é um URL externo e será aberto em uma nova janela. Abrir?',
  resourceDetailsLinkOpenButtonTitle: 'Abrir',
  resourceDetailsLinkOpenAgainButtonTitle: 'Abrir Novamente',
  resourceDetailsLinkCopyURLButtonTitle: 'Copiar URL de destino',
  resourceDetailsLinkCopiedURLAlertText: 'URL copiado!',
  resurceDetailsLinkCurtainOptionCopyText: 'Copiar link',
  resourceDetailsFileInfoLastUpdText: 'Última atualização',
  resourceDetailsFileInfoUploadText: 'Enviado',
  resourceDetailsFileSaveButtonTitle: 'Abrir',
  resourceDetailsFileCopyButtonTitle: 'Copiar link',
  resourcesOwnersCurtainCopyOptionText: 'Copiar link',
  resourceDetailsFileLoadingText: 'Carregando...',
  resourceDetailsImageCurtainCopyOptionText: 'Copiar link',
  resourceDetailsImageCurtainDownloadOptionText: 'Baixar',
  resourceFolder: 'Pasta',
  resourceAdded: 'Adicionado'
}
